import {
  DataTableFilter,
  ExpensesExpensableFilter,
  FilterType,
} from 'generated/resources/datatable.graphql'

import i18n from 'modules/core/lib/i18n'

import type { BaseFilterProps } from './types'
import { trackFilters } from './utils'

const expenseTypeFilter = ({
  expensesContext,
  initialFilterValues,
}: BaseFilterProps): DataTableFilter<ExpensesExpensableFilter> => {
  const options = [
    {
      label: i18n.t('expenses_v2.types.automatic'),
      value: 'automatic',
    },
    {
      label: i18n.t('expenses_v2.types.manual'),
      value: 'manual',
    },
  ]

  return {
    type: FilterType.String,
    categories: [
      {
        kind: 'SingleChoice',
        operation: 'eq',
        options,
        value: initialFilterValues.creationType ? initialFilterValues.creationType : undefined,
      },
    ],
    onUpdateValue: () => {
      trackFilters('type', expensesContext)
    },
    identifier: 'expensesList.expenseTypeFilter',
    path: 'creationType',
    title: i18n.t('expenses_v2.forms.fields.creation_type.label'),
    default: !!initialFilterValues.creationType,
  }
}

export default expenseTypeFilter
